import { Observable } from "rxjs";
import { get } from "../../../service/api";
import { ITokenPair } from "../../auth/interface/dto/token-pair";

export const getStates = (tokens: ITokenPair): Observable<Array<string>> =>
    get<Array<string>>("/common/states", undefined, tokens);
